import { _ as _objectSpread2, v as variables, i as colors, s as shadows, z as zIndices } from './transitions-0cec78fb.esm.js';
import { borderPresets, borderPreset, borderWidthPresets, typography as typography$1, borderWidths, breakpoints, motion, radii } from '@hover/blueprint-theme';
import { fromEntries } from '@hover/utilities';
import 'ramda/src/values';
import 'ramda/src/mapObjIndexed';
import 'ramda/src/map';
import 'ramda/src/mergeDeepWith';
import { s as sizes } from './sizes-77976ad9.esm.js';
import { s as space } from './space-a5a5bc2c.esm.js';
import { t as textStyles } from './textStyles-2d4d9724.esm.js';
import * as tokens from '@hover/tokens-typography';
import 'polished';

var borders = /*#__PURE__*/_objectSpread2( /*#__PURE__*/_objectSpread2({}, /*#__PURE__*/fromEntries( /*#__PURE__*/borderPresets.map(function (preset) {
  return [preset, borderPreset(variables.color("border.".concat(preset)).reference)];
}))), borderWidthPresets);

var typography = /*#__PURE__*/_objectSpread2( /*#__PURE__*/_objectSpread2({}, typography$1), {}, {
  fonts: {
    heading: tokens.familyBrand,
    body: tokens.familyBody,
    mono: tokens.familyCode
  }
});

/**
 * Combined foundations object for use in `extendTheme`
 *
 * @example
 * import { extendTheme } from '@chakra-ui/react';
 * import { foundations } from '.';
 *
 * ```ts
 * const theme = extendTheme({ ...foundations });
 * ```
 */
var foundations = /*#__PURE__*/_objectSpread2({
  borderWidths: borderWidths,
  borders: borders,
  breakpoints: breakpoints,
  colors: colors,
  motion: motion,
  radii: radii,
  shadows: shadows,
  sizes: sizes,
  space: space,
  textStyles: textStyles,
  zIndices: zIndices
}, typography);

export { borders as b, foundations as f, typography as t };
